export default __webpack_public_path__ + "static/media/topic0-bg0.159bc66e.png";